import './ProductListPlaceholder.scss';

import { registryComponent } from '@boost-sd/components-registry/registry';
import Placeholder from '@components/Placeholder';
import { createClsNameMap, mapModifiers } from '@utils';
import { Fragment } from 'react';

export type ProductListPlaceholderProps = {
  productListLayout: 'grid' | 'list';
  columns?: number;
  rows?: number;
};

export const clsNameMap = createClsNameMap({
  elements: {
    item: createClsNameMap(),
    text: createClsNameMap(),
  },
  modifiers: ['list-col'],
})('product-list-placeholder');

const ProductListPlaceholder = ({
  columns = 4,
  rows = 4,
  productListLayout,
}: ProductListPlaceholderProps) => {
  /**
   * List View
   */
  if (productListLayout === 'list') {
    return (
      <div className={mapModifiers(clsNameMap, ['list-col'])}>
        <div className={clsNameMap.elm('item')}>
          <Placeholder width={160} height={220} style={{ borderRadius: 0 }} />
          <div className={clsNameMap.elm('text')}>
            <Placeholder style={{ marginBottom: 18 }} />
            <Placeholder width='80%' style={{ marginBottom: 18 }} />
            <Placeholder width='40%' style={{ marginBottom: 18 }} />
            <Placeholder width='65%' style={{ marginBottom: 18 }} />
          </div>
        </div>
      </div>
    );
  }

  /**
   * Grid View
   * Set default rows to 4 to expand the product list placeholder beyond 800px of viewport height to avoid layout shift
   */
  return (
    <div className={clsNameMap.root()} style={{ gridTemplateColumns: `repeat(${columns}, 1fr) ` }}>
      {Array.from({ length: rows }, (_, i) => (
        <Fragment key={i}>
          {Array.from({ length: columns }, (_, i) => (
            <div className={clsNameMap.elm('item')} key={i}>
              <Placeholder height={220} style={{ borderRadius: 0 }} />
              <Placeholder />
              <Placeholder width='80%' />
              <Placeholder width='40%' />
            </div>
          ))}
        </Fragment>
      ))}
    </div>
  );
};

export default registryComponent('ProductListPlaceholder', ProductListPlaceholder);
